import isAdminSelector from 'root/src/client/logic/auth/selectors/isAdminSelector'
import isBrandDropEventSelector from 'root/src/client/logic/dropEvent/selectors/isBrandDropEventSelector'

export default (state) => {
	const isAdmin = isAdminSelector(state)
	const isBrandDrop = isBrandDropEventSelector(state)
	return isAdmin || isBrandDrop
}
